import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useCallback } from "react";
import { makeStyles } from "tss-react/mui";
import { grey } from "@mui/material/colors";
import moment from "moment";
import { dateFormat } from "./DateCell";
import clsx from "clsx";
import { formatCents } from "nate-react-api-helpers";
import { dateTimeFormat } from "./DateTimeCell";
import { ensurePrecision } from "./MoneyFloatCell";
import { timeFormat } from "./TimeCell";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ placeholderText: { color: grey["600"], fontSize: "0.85rem", flex: 1 }, valueText: { fontSize: "0.85rem", flex: 1 }, leftAlign: { textAlign: "left" }, rightAlign: { textAlign: "right" }, tableCellDisabled: { background: grey["200"] }, tableCellDefault: { display: "flex", alignItems: "center", width: "100%", height: "100%", border: "2px solid transparent", paddingLeft: "13px !important", paddingRight: "5px !important" }, tableCellEnabled: { borderRadius: 4, "&:hover": { border: "2px solid " + theme.palette.primary.main } }, dropArrow: { borderRadius: "50%", cursor: "pointer", "&:hover": { background: grey["200"] } } }); });
export function ValueCell(props) {
    var _a;
    var styles = useStyles().classes;
    var _onClick = props.onClick;
    var onClick = useCallback(function (e) { if (!_onClick)
        return; var el = e.currentTarget; while (el.tagName !== "TD")
        el = el.parentElement; el.style.width = window.getComputedStyle(el).width; _onClick(); }, [_onClick]);
    return /*#__PURE__*/ _jsxs("div", { className: clsx((_a = {}, _a[styles.tableCellDefault] = true, _a[styles.tableCellDisabled] = props.column.type === "computed" || props.locked, _a["computed-cell-value"] = props.column.type === "computed" || props.locked, _a[styles.tableCellEnabled] = props.column.type !== "computed" && !props.locked, _a)), onClick: onClick, children: [props.value || props.value === 0 ? /*#__PURE__*/ _jsx(RealValue, { row: props.row, value: props.value, column: props.column }) : /*#__PURE__*/ _jsx(PlaceholderValue, { column: props.column }), (props.column.type === "date" || props.column.type === "date-time" || props.column.type === "time" || props.column.type === "select-from-list" || props.column.type === "select-entity-from-list") && /*#__PURE__*/ _jsx(ArrowDropDownIcon, { className: styles.dropArrow })] });
}
export function valueToString(row, value, column) { switch (column.type) {
    case "date": return moment(value).format(column.displayFormat || dateFormat);
    case "date-time": return moment(value).format(column.displayFormat || dateTimeFormat);
    case "time": return moment(value).format(column.displayFormat || timeFormat);
    case "money-float": return ensurePrecision(value / 100, 2);
    case "money": return formatCents(value);
    case "number": return value.toString();
    case "select-from-list":
        if (column.displayKey && row[column.displayKey]) {
            return row[column.displayKey];
        }
        return value.toString();
    case "select-entity-from-list": return row[column.displayKey];
    case "float": return value.toFixed(3);
    default: return value.toString();
} }
function RealValue(props) {
    var _a;
    var styles = useStyles().classes;
    var alignment;
    if (props.column.align !== undefined) {
        alignment = props.column.align;
    }
    else {
        switch (props.column.type) {
            case "date-time":
            case "time":
            case "float":
            case "money":
            case "money-float":
            case "number":
                alignment = "right";
                break;
            case "computed":
            case "date":
            case "select-entity-from-list":
            case "select-from-list":
            default:
                alignment = "left";
                break;
        }
    }
    return /*#__PURE__*/ _jsx("span", { className: clsx((_a = {}, _a[styles.valueText] = true, _a[styles.leftAlign] = alignment === "left", _a[styles.rightAlign] = alignment === "right", _a)), children: valueToString(props.row, props.value, props.column) });
}
function PlaceholderValue(props) {
    var _a;
    var styles = useStyles().classes;
    var alignRight = props.column.align === "right";
    switch (props.column.type) {
        case "number":
        case "money-float":
        case "money":
        case "float":
            alignRight = true;
            break;
    }
    return /*#__PURE__*/ _jsx("span", { className: clsx((_a = {}, _a[styles.placeholderText] = true, _a[styles.rightAlign] = alignRight, _a)), children: props.column.placeholder || /*#__PURE__*/ _jsx("span", { dangerouslySetInnerHTML: { __html: "&nbsp;" } }) });
}
